import { render } from "./AlertWarning.vue?vue&type=template&id=3e9a9f2c"
import script from "./AlertWarning.vue?vue&type=script&lang=js"
export * from "./AlertWarning.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__